import firebase from '@firebase/app-compat';
export { default } from '@firebase/app-compat';

var name = "firebase";
var version = "9.6.8";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
firebase.registerVersion(name, version, 'app-compat');
//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ../firebase_sdk-20260526/packages/firebase/compat/app/dist/index.esm.js
// module id = gQ3y
// module chunks = 21